<template>
  <!-- Modal avec Teleport pour full screen -->
  <Teleport to="body">
    <div v-if="showModal" class="fixed inset-0 bg-[#0000009e] flex items-center justify-center z-50" @click="closeModal">
      <div
        class="bg-white rounded-lg p-6 max-w-4xl w-full mx-4 max-h-[90vh] overflow-y-auto transition-all duration-300 ease-in-out" @click.stop>
        <div class="flex justify-between items-center mb-4">
          <h2 class="text-2xl font-bold">
            {{ mode === 'create' ? 'Nouvelle entité matérielle' :
              mode === 'duplicate' ? 'Dupliquer l\'entité matérielle' :
                'Modifier l\'entité matérielle' }}
          </h2>
          <button class="text-gray-500 hover:text-gray-700" @click="closeModal">
            <XIcon class="h-6 w-6" />
          </button>
        </div>

        <!-- Formulaire manuel -->
        <div class="space-y-4">
          <div>
            <label class="block text-sm font-medium text-gray-700">Appellation</label>
            <input v-model="materialEntityData.appellation"
              class="mt-1 block w-full rounded-md border border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
              placeholder="Nom de l'objet" />
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700">Identifiant</label>
            <input v-model="materialEntityData.identifier"
              class="mt-1 block w-full rounded-md border border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
              placeholder="Numéro d'inventaire de l'objet" />
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700">Type</label>
            <input v-model="materialEntityData.type"
              class="mt-1 block w-full rounded-md border border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
              placeholder="Artefact, monument, peinture" />
          </div>
          <div>
            <button class="text-blue-500 hover:text-blue-700" @click="showEntityFields = !showEntityFields">
              Préciser l'entité?
            </button>
            <div v-if="showEntityFields">
              <div>
                <label class="block text-sm font-medium text-gray-700">Matériau</label>
                <input v-model="materialEntityData.material"
                  class="mt-1 block w-full rounded-md border border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                  placeholder="Pierre, bois, métal" />
              </div>
              <div>
                <label class="block text-sm font-medium text-gray-700">État de surface</label>
                <input v-model="materialEntityData.surface_state"
                  class="mt-1 block w-full rounded-md border border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                  placeholder="Bon état, Usé, Restauré" />
              </div>
              <div>
                <label class="block text-sm font-medium text-gray-700">Lien</label>
                <input v-model="materialEntityData.me_link"
                  class="mt-1 block w-full rounded-md border border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                  placeholder="https://example.com/objet" />
              </div>
              <div>
                <label class="block text-sm font-medium text-gray-700">Notes matériau</label>
                <textarea v-model="materialEntityData.material_notes"
                  class="mt-1 block w-full rounded-md border border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                  placeholder="Notes sur le matériau, conservation..." rows="3" />
              </div>
              <div>
                <label class="block text-sm font-medium text-gray-700">Échelle</label>
                <input v-model="materialEntityData.scale"
                  class="mt-1 block w-full rounded-md border border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                  placeholder="1:1, 1:10, etc." />
              </div>
              <div>
                <label class="block text-sm font-medium text-gray-700">Propriétaire</label>
                <input v-model="materialEntityData.me_owner"
                  class="mt-1 block w-full rounded-md border border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                  placeholder="Musée, Collection privée, etc." />
              </div>
            </div>
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700">Provenance</label>
            <LocationSelector :user-id="userId" :initial-location-id="provenanceId"
              @location-selected="handleLocationSelected" @location-reset="handleLocationReset" />
          </div>
          <div>
            <button class="text-blue-500 hover:text-blue-700" @click="showProvenanceFields = !showProvenanceFields">
              Préciser la provenance?
            </button>
            <div v-if="showProvenanceFields">
              <div>
                <label class="block text-sm font-medium text-gray-700">Intérieur/Extérieur</label>
                <input v-model="materialEntityData.provenance_interior_exterior"
                  class="mt-1 block w-full rounded-md border border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                  placeholder="Salle des Gardes, Cour intérieure" />
              </div>
              <div>
                <label class="block text-sm font-medium text-gray-700">Zonage</label>
                <input v-model="materialEntityData.provenance_zoning"
                  class="mt-1 block w-full rounded-md border border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                  placeholder="Zone nord, Zone sud" />
              </div>
              <div>
                <label class="block text-sm font-medium text-gray-700">Étage</label>
                <input v-model="materialEntityData.provenance_floor"
                  class="mt-1 block w-full rounded-md border border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                  placeholder="Étage 1, Rez-de-chaussée" />
              </div>
              <div>
                <label class="block text-sm font-medium text-gray-700">Orientation</label>
                <input v-model="materialEntityData.provenance_orientation"
                  class="mt-1 block w-full rounded-md border border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                  placeholder="Nord, Sud, Est, Ouest" />
              </div>
              <div>
                <label class="block text-sm font-medium text-gray-700">Nomenclature</label>
                <input v-model="materialEntityData.provenance_nomenclature"
                  class="mt-1 block w-full rounded-md border border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                  placeholder="Nomenclature spécifique" />
              </div>
            </div>
          </div>
        </div>

        <div class="flex justify-between mt-6">
          <div class="ml-auto">
            <button class="px-4 py-2 bg-green-500 text-white rounded-md hover:bg-green-600" @click="handleSubmit">
              {{ mode === 'create' ? 'Créer l\'entité matérielle' :
                mode === 'duplicate' ? 'Créer la copie' :
                  'Mettre à jour l\'entité matérielle' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </Teleport>

  <!-- Modal de confirmation -->
  <ModalAreYouSure
    v-model="showConfirmModal"
    title="Modifications non sauvegardées"
    message="Vous avez des modifications non sauvegardées. Êtes-vous sûr de vouloir fermer sans sauvegarder ?"
    confirm-text="Fermer sans sauvegarder"
    cancel-text="Continuer l'édition"
    @confirm="confirmClose"
    @cancel="cancelClose"
  />

  <!-- Notification -->
  <Notification ref="notification" />
</template>

<script lang="ts">
import { XIcon } from 'lucide-vue-next';
import type { PropType } from 'vue';
import { defineComponent, reactive, ref, watch, computed } from 'vue';
import { materialEntities } from '../../api/materialEntities';
import type { MaterialEntity, MaterialEntityCreate } from '../../api/types/entities/materialEntity/types';
import Notification from '../Notification.vue';
import LocationSelector from '../selectors/LocationSelector.vue';
import ModalAreYouSure from '../utils/modal_areyousure.vue';

export default defineComponent({
  name: 'MaterialEntityCreator',
  components: {
    XIcon,
    LocationSelector,
    Notification,
    ModalAreYouSure
  },
  props: {
    userId: {
      type: String,
      required: true
    },
    mode: {
      type: String as PropType<'create' | 'edit' | 'duplicate'>,
      default: 'create'
    },
    initialData: {
      type: Object as PropType<MaterialEntity>,
      default: null
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  emits: ['material-entity-created', 'material-entity-updated', 'update:show'],
  setup(props, { emit }) {
    const showModal = ref(props.show);
    const showProvenanceFields = ref(false);
    const showEntityFields = ref(false);
    const notification = ref<InstanceType<typeof Notification> | null>(null);
    const showConfirmModal = ref(false);
    const initialDataSnapshot = ref<MaterialEntityCreate | null>(null);

    const materialEntityData = reactive<MaterialEntityCreate>({
      user_id: props.userId,
      appellation: '',
      identifier: '',
      type: '',
      material: '',
      surface_state: '',
      me_link: '',
      material_notes: '',
      scale: '',
      me_owner: '',
      provenance: '',
      provenance_interior_exterior: '',
      provenance_zoning: '',
      provenance_floor: '',
      provenance_orientation: '',
      provenance_nomenclature: '',
      is_public: true
    });

    // Surveiller les changements de la prop show
    watch(() => props.show, (newValue) => {
      showModal.value = newValue;
    });

    // Surveiller les changements de showModal
    watch(showModal, (newValue) => {
      emit('update:show', newValue);
    });

    // Initialiser les données si en mode édition ou duplication
    watch(() => props.initialData, (newData) => {
      if (newData && (props.mode === 'edit' || props.mode === 'duplicate')) {
        Object.assign(materialEntityData, {
          user_id: props.mode === 'edit' ? newData.user_id : props.userId,
          // En mode duplicate, ne pas copier l'UUID pour éviter les conflits
          uuid: props.mode === 'duplicate' ? undefined : newData.uuid,
          appellation: props.mode === 'duplicate' ? `Copie de ${newData.appellation}` : newData.appellation,
          identifier: newData.identifier || '',
          type: newData.type || '',
          material: newData.material || '',
          surface_state: newData.surface_state || '',
          me_link: newData.me_link || '',
          material_notes: newData.material_notes || '',
          scale: newData.scale || '',
          me_owner: newData.me_owner || '',
          provenance: (newData as any).provenance_location?.uuid || (typeof (newData as any).provenance === 'string' ? (newData as any).provenance : '') || '',
          provenance_interior_exterior: newData.provenance_interior_exterior || '',
          provenance_zoning: newData.provenance_zoning || '',
          provenance_floor: newData.provenance_floor || '',
          provenance_orientation: newData.provenance_orientation || '',
          provenance_nomenclature: newData.provenance_nomenclature || '',
          is_public: props.mode === 'edit' ? newData.is_public : false
        });

        if (newData.provenance_interior_exterior ||
          newData.provenance_zoning ||
          newData.provenance_floor ||
          newData.provenance_orientation ||
          newData.provenance_nomenclature) {
          showProvenanceFields.value = true;
        }

        if (newData.material ||
          newData.surface_state ||
          newData.me_link ||
          newData.material_notes ||
          newData.scale ||
          newData.me_owner) {
          showEntityFields.value = true;
        }
      }
    }, { immediate: true });

    // Ajout : watcher pour pré-remplir à chaque ouverture de la modale avec les données d'import, quel que soit le mode
    watch([
      () => props.initialData,
      showModal
    ], ([newData, modalVisible]) => {
      if (modalVisible && newData) {
        Object.assign(materialEntityData, {
          user_id: newData.user_id || props.userId,
          // En mode duplicate, ne pas copier l'UUID pour éviter les conflits
          uuid: props.mode === 'duplicate' ? undefined : (newData.uuid || undefined),
          appellation: newData.appellation || '',
          identifier: newData.identifier || '',
          type: newData.type || '',
          material: newData.material || '',
          surface_state: newData.surface_state || '',
          me_link: newData.me_link || '',
          material_notes: newData.material_notes || '',
          scale: newData.scale || '',
          me_owner: newData.me_owner || '',
          provenance: (newData as any).provenance_location?.uuid || (typeof (newData as any).provenance === 'string' ? (newData as any).provenance : '') || '',
          provenance_interior_exterior: newData.provenance_interior_exterior || '',
          provenance_zoning: newData.provenance_zoning || '',
          provenance_floor: newData.provenance_floor || '',
          provenance_orientation: newData.provenance_orientation || '',
          provenance_nomenclature: newData.provenance_nomenclature || '',
          is_public: newData.is_public ?? false
        });

        if (newData.provenance_interior_exterior ||
          newData.provenance_zoning ||
          newData.provenance_floor ||
          newData.provenance_orientation ||
          newData.provenance_nomenclature) {
          showProvenanceFields.value = true;
        }

        if (newData.material ||
          newData.surface_state ||
          newData.me_link ||
          newData.material_notes ||
          newData.scale ||
          newData.me_owner) {
          showEntityFields.value = true;
        }
        // Sauvegarder un snapshot des données initiales pour la comparaison
        initialDataSnapshot.value = JSON.parse(JSON.stringify(materialEntityData));
      } else {
        // Modal fermée ou pas de données
        // Réinitialiser le snapshot quand le modal se ferme
        if (!modalVisible) {
          initialDataSnapshot.value = null;
        }
      }
    }, { immediate: true });

    const handleLocationSelected = (location: any): void => {
      // Extraire l'UUID de l'objet Location
      materialEntityData.provenance = location?.uuid || '';
    };

    const handleLocationReset = (): void => {
      materialEntityData.provenance = '';
    };

    // Computed pour s'assurer que provenance est toujours une chaîne
    const provenanceId = computed(() => {
      const provenance = materialEntityData.provenance;
      if (typeof provenance === 'string') {
        return provenance;
      }
      if (provenance && typeof provenance === 'object' && 'uuid' in provenance) {
        return (provenance as any).uuid;
      }
      return '';
    });

    // Fonction pour vérifier s'il y a des modifications
    const hasModifications = (): boolean => {
      if (!initialDataSnapshot.value) {
        // En mode création, vérifier si des champs ont été remplis
        return !!(materialEntityData.appellation || materialEntityData.identifier || materialEntityData.type || 
                 materialEntityData.material || materialEntityData.surface_state || materialEntityData.me_link || 
                 materialEntityData.material_notes || materialEntityData.scale || materialEntityData.me_owner || 
                 materialEntityData.provenance || materialEntityData.provenance_interior_exterior || 
                 materialEntityData.provenance_zoning || materialEntityData.provenance_floor || 
                 materialEntityData.provenance_orientation || materialEntityData.provenance_nomenclature);
      }
      
      // En mode édition, comparer avec les données initiales
      const snapshot = initialDataSnapshot.value;
      return materialEntityData.appellation !== snapshot.appellation ||
             materialEntityData.identifier !== snapshot.identifier ||
             materialEntityData.type !== snapshot.type ||
             materialEntityData.material !== snapshot.material ||
             materialEntityData.surface_state !== snapshot.surface_state ||
             materialEntityData.me_link !== snapshot.me_link ||
             materialEntityData.material_notes !== snapshot.material_notes ||
             materialEntityData.scale !== snapshot.scale ||
             materialEntityData.me_owner !== snapshot.me_owner ||
             materialEntityData.provenance !== snapshot.provenance ||
             materialEntityData.provenance_interior_exterior !== snapshot.provenance_interior_exterior ||
             materialEntityData.provenance_zoning !== snapshot.provenance_zoning ||
             materialEntityData.provenance_floor !== snapshot.provenance_floor ||
             materialEntityData.provenance_orientation !== snapshot.provenance_orientation ||
             materialEntityData.provenance_nomenclature !== snapshot.provenance_nomenclature;
    };

    const closeModal = (): void => {
      if (hasModifications()) {
        showConfirmModal.value = true;
      } else {
        resetForm();
        showModal.value = false;
      }
    };

    const confirmClose = (): void => {
      showConfirmModal.value = false;
      resetForm();
      showModal.value = false;
    };

    const cancelClose = (): void => {
      showConfirmModal.value = false;
    };

    const resetForm = (): void => {
      Object.assign(materialEntityData, {
        user_id: props.userId,
        appellation: '',
        identifier: '',
        type: '',
        material: '',
        surface_state: '',
        me_link: '',
        material_notes: '',
        scale: '',
        me_owner: '',
        provenance: '',
        provenance_interior_exterior: '',
        provenance_zoning: '',
        provenance_floor: '',
        provenance_orientation: '',
        provenance_nomenclature: '',
        is_public: true
      });
      showProvenanceFields.value = false;
      showEntityFields.value = false;
      // Réinitialiser le snapshot
      initialDataSnapshot.value = null;
    };

    const handleSubmit = async (): Promise<void> => {
      try {
        if (props.mode === 'create' || props.mode === 'duplicate') {
          const response = await materialEntities.createMaterialEntity(materialEntityData);
          emit('material-entity-created', response);
          if (notification.value) {
            notification.value.showNotification('Entité matérielle créée avec succès', 'success');
          }
          resetForm();
          showModal.value = false;
        } else {
          const response = await materialEntities.updateMaterialEntity(props.initialData?.uuid || '', materialEntityData);
          emit('material-entity-updated', response);
          if (notification.value) {
            notification.value.showNotification('Entité matérielle mise à jour avec succès', 'success');
          }
          resetForm();
          showModal.value = false;
        }
      } catch (error) {
        console.error(`Erreur lors de ${props.mode === 'edit' ? 'la mise à jour' : 'la création'} de l'entité matérielle:`, error);
        if (notification.value) {
          notification.value.showNotification('Erreur lors de la création/mise à jour de l\'entité matérielle', 'error');
        }
      }
    };

    return {
      showModal,
      showProvenanceFields,
      showEntityFields,
      materialEntityData,
      provenanceId,
      handleSubmit,
      handleLocationSelected,
      handleLocationReset,
      closeModal,
      notification,
      showConfirmModal,
      confirmClose,
      cancelClose
    };
  }
});
</script>

<style scoped>
/* Ajouter des styles pour aligner la carte avec les autres cartes */
.bg-white {
  height: 100%;
}

/* Forcer les styles pour tous les inputs dans MaterialEntityCreator */
input[type="text"],
input[type="email"],
input[type="url"],
input[type="password"],
input[type="number"],
input:not([type]),
textarea,
select {
  margin-bottom: 8px !important;
  border: 1px solid #d1d5db !important;
  /* border-gray-300 */
  border-radius: 6px !important;
  /* rounded-md */
  padding: 8px 12px !important;
  /* px-3 py-2 */
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05) !important;
  /* shadow-sm */
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out !important;
  background-color: white !important;
  width: 100% !important;
  display: block !important;
}

input[type="text"]:focus,
input[type="email"]:focus,
input[type="url"]:focus,
input[type="password"]:focus,
input[type="number"]:focus,
input:not([type]):focus,
textarea:focus,
select:focus {
  outline: none !important;
  border-color: #3b82f6 !important;
  /* border-blue-500 */
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1) !important;
  /* ring-blue-500 */
}

input::placeholder,
textarea::placeholder {
  color: #9ca3af !important;
  /* text-gray-400 */
}

/* Labels */
label {
  margin-bottom: 4px !important;
  display: block !important;
  font-weight: 500 !important;
  color: #374151 !important;
  /* text-gray-700 */
  font-size: 0.875rem !important;
  /* text-sm */
}
</style>